import React from 'react';

import { Dashboard, ErrorHandler } from '../../api';
import { Widget } from '../Widget/Widget';
import { numberWithCommas } from '../../utils';
import AreaChartBlockedDNSWidget from './AreaChartBlockedDNSWidget';

import './WidgetBlockedDNS.scss';

export default class WidgetBlockedDNS extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      blockedCount: null,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this._fetch();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  safeSetState = (newState, callback) => {
    if (this._isMounted) {
      this.setState(newState, callback);
    }
  };

  _fetch = async () => {
    this.safeSetState({ isLoading: true });

    let res;
    try {
      res = await Dashboard.dnsBlockedCount();
    } catch (err) {
      ErrorHandler.error(err);
    }

    let blockedCount = null;
    let eventData = null;
    if (res && res.body && res.body.data) {
      const { data } = res.body;
      eventData = data.count_by_hour;
      eventData = eventData.sort().reverse();
      blockedCount = data.total_count;
    }

    this.safeSetState({
      eventData,
      isLoading: false,
      blockedCount,
    });
  };

  render() {
    const { blockedCount, isLoading, eventData } = this.state;
    return (
      <Widget
        title="Blocked DNS Requests"
        subtitle="in last 24 hours"
        isLoading={isLoading}
        link="/devices/dns-activity"
        widgetName="WidgetBlockedDNS"
        isEmpty={!blockedCount && blockedCount !== 0}
        emptyStateMessage="No DNS requests blocked in the last 24 hours."
        className="BlockedDNSRequests-widget height-3">
        <div className="blockedCount">{numberWithCommas(blockedCount)}</div>
        <AreaChartBlockedDNSWidget data={eventData} isLoading={isLoading} />
      </Widget>
    );
  }
}
